module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-completing-the-work.fcc435c9.webp";